/* eslint-disable max-len */
import { CatalogFileCollection, PriceData } from '../../common/libraries/fileFormats/catalog/catalog';
import { CatalogObjectDisplayObject } from '../Data/CatalogObjectDisplayObject';
import { CollectionToShow } from '../Data/CollectionToShow';
import { POSCatalogModelData } from '../../common/libraries/modelViewer/Data/POSCatalogData';
import { FilePaths } from '../../common/libraries/fileSystem/filePaths';
import { SLTXUtil } from '../../common/libraries/fileFormats/sltx/sltxUtil';

export class CatalogObjectDisplay {

  static GetCatalogObjectImages(
    catalogObject : POSCatalogModelData,
    catalogPath : string,
  ): string[] {

    // Check if this item has variants.
    // If so, build an array with the images to all thumbnails to each variant
    // If not return an array with the image to the general thumbnail

    if (catalogObject.data) {

      const catalogObjectVariants = catalogObject.data.variants;

      if (catalogObjectVariants && catalogObjectVariants.length > 0) {
        const arrImages = new Array<string>();
        catalogObjectVariants.forEach((variant) => {
          if (variant.name !== SLTXUtil.DummyOption) {
            const filePath = FilePaths.join(
              catalogPath,
              FilePaths.join(
                catalogObject.getResourcesPath(),
                variant.imageRef,
              ),
            );
            arrImages.push(filePath);
          }
        });

        if (arrImages.length > 0) return arrImages;
      }
    }

    if (catalogObject.catalogData) {
      const arrImages = catalogObject.catalogData.imageRef;
      if (arrImages && arrImages.length > 0) {
        return [FilePaths.join(catalogPath, arrImages[0])];
      }
    }

    return [];
  }

  static CreateCatalogObjectDisplayObject(
    collection : CollectionToShow,
    catalogObject: POSCatalogModelData,
    id : number,
    catalogPath : string,
    priceData: PriceData[],
  ) : CatalogObjectDisplayObject {

    const objectName = catalogObject.catalogData ? catalogObject.catalogData.name : '';
    const objectPrice = catalogObject.catalogData && catalogObject.getPrice(priceData) > 0 ? `${catalogObject.getPrice(priceData)}` : '';
    const collectionName = collection.name;
    const objectDisplayPriority = catalogObject.catalogData ? catalogObject.catalogData.displayPriority : '';

    // Create new object

    const result = new CatalogObjectDisplayObject();

    result.id = collection.name + id;
    result.name = objectName;
    result.displayPriority = objectDisplayPriority;
    result.price = objectPrice;
    result.collectionName = collectionName;
    result.imageURL = this.GetCatalogObjectImages(
      catalogObject,
      catalogPath,
    );
    result.url = `${collectionName}/${objectName}`;
    if (catalogObject.catalogData) {
      result.tags = catalogObject.catalogData.tags;
    }
    result.height = '200px';
    result.width = '250px';

    return result;
  }

  static CreateCatalogObjectDisplayObject2(
    collection : CatalogFileCollection,
    catalogObject: POSCatalogModelData,
    id : number,
    catalogPath : string,
    priceData: PriceData[],
  ) : CatalogObjectDisplayObject {

    const objectName = catalogObject.catalogData ? catalogObject.catalogData.name : '';
    const objectDisplayPriority = catalogObject.catalogData ? catalogObject.catalogData.displayPriority : '';
    const objectPrice = catalogObject.catalogData && catalogObject.getPrice(priceData) > 0 ? `${catalogObject.getPrice(priceData)}` : '';
    const collectionName = collection.name;

    // Create new object

    const result = new CatalogObjectDisplayObject();

    result.id = collection.name + id;
    result.name = objectName;
    result.displayPriority = objectDisplayPriority;
    result.price = objectPrice;
    result.collectionName = collectionName;
    result.imageURL = this.GetCatalogObjectImages(
      catalogObject,
      catalogPath,
    );
    result.url = `${collectionName}/${objectName}`;
    if (catalogObject.catalogData) {
      result.tags = catalogObject.catalogData.tags;
    }
    result.height = '200px';
    result.width = '250px';

    return result;
  }

}
